// extracted by mini-css-extract-plugin
module.exports = {"relative-loading":"LoadingSpinner_relative-loading__1egW2"};